import { FontWeights, makeStyles } from '@fluentui/react';
import { Background } from '@xyflow/react';
export const useStyles = makeStyles((theme) => ({
  headerStyle: {
    backgroundColor: theme.palette.white,
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 999,
  },
  deleteIconStyle: {
    marginLeft: 'auto',
    paddingRight: 10,
  },
}));
